module.exports = __webpack_public_path__ + "static/media/img_title1@3x.50ee236d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_title1@3x.png
// module id = 778
// module chunks = 0